class SiteDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.drawers = window.BAO.Utils.getElement('site-drawers')

    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawerShouldBeMoved) {
      window.setTimeout(() => {
        this.moveToElement.appendChild(this)
      }, parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0)
    }
  }

  setupListeners () {
    super.setupListeners()
    this.handleAnimationEnd = this.handleAnimationEnd.bind(this)
    this.listeners.add(this, 'transitionend', this.handleAnimationEnd)
  }

  handleAnimationEnd (event) {
    if (event?.propertyName !== `transform`) return
    this.classList.toggle(this.config.classes.activeDrawerOpen, this.isOpen)
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: window.BAO.Utils.getElement(
        `[data-drawers-trigger=${this.key}]`,
      ),
      close: window.BAO.Utils.getElement(
        `[data-module-drawers-close=${this.key}]`,
      ),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      default:
        return window.BAO.Utils.getElement(
          this.getAttribute('data-module-drawers-move-me'),
        )
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
        activeDrawerOpen: 'drw-Drawer-open',
      },
    }
  }
}

if (!customElements.get('site-drawer')) {
  customElements.define('site-drawer', SiteDrawer)
}
